import { Button } from "primereact/button";
import { FileUpload, FileUploadHandlerEvent } from "primereact/fileupload";
import { Panel } from "primereact/panel";
import { CSSProperties, useEffect, useRef, useState } from "react";
import ReportService from "service/reports/ReportService";
import saveAs from 'file-saver';
import { useToastContext } from "components/alert/ToastContext";

type Props = {
    titulo: string;
    nomeAcao: string;
    testarRelatorio: () => void;
    style: CSSProperties;

}

const reportService = new ReportService();

const DefaultReportEdit = (props: Props) => {

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [fileRelatorio, setFileRelatorio] = useState<File>();
    const [nomeArquivoRelatorio, setNomeArquivoRelatorio] = useState<string | null>(null);
    const inputRelatorioFileRef = useRef<any>();

    function onUploadRelatorio(e: FileUploadHandlerEvent) {
        const file = e.files[0];
        setFileRelatorio(file);
        setNomeArquivoRelatorio(file.name);
    }

    useEffect(() => {
        buscarNomeArquivo();
    }, [])

    function buscarNomeArquivo() {
        reportService.getNomeReport(props.nomeAcao).then(data => {
            setNomeArquivoRelatorio(data);
        }).catch(err => {
            console.log(err);
        });
    }

    function downloadRelatorio() {
        reportService.getReport(props.nomeAcao).then(data => {
            const file = new Blob([data]);
            saveAs(file, nomeArquivoRelatorio as string);
        }).catch(err => {
            console.log(err);
        });
    }

    function gravarReport() {
        if (!fileRelatorio) {
            return;
        }
        reportService.gravarReport(props.nomeAcao, fileRelatorio).then(() => {
            msgSucesso("Sucesso", "Relatório salvo com sucesso");
            setFileRelatorio(undefined);
            setNomeArquivoRelatorio(fileRelatorio?.name);
            inputRelatorioFileRef.current.clear();
        }).catch(err => {
            msgErro("Erro", "Erro ao salvar relatório");
            console.log(err);
        });

    }

    return (
        <Panel style={props.style} header={props.titulo} footer={
            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <Button label="Gravar" className="ui-button-info" onClick={() => {

                    gravarReport();

                }} ></Button>
            </div>
        }>

            <div className="row">
                <div className="col-sm-12">

                    <div>
                        <label className="col col-sm-12">Escolha outro arquivo para trocar o arquivo existente</label>
                        {nomeArquivoRelatorio ?
                            <>
                                <a
                                    className="col col-sm-12"
                                    style={{ color: '#3CA4FF', textDecoration: 'underline', textDecorationColor: '#3CA4FF', cursor: 'pointer' }}
                                    onClick={() => {

                                        downloadRelatorio();

                                        return false;
                                    }}>{nomeArquivoRelatorio}</a>

                                <div className="col-sm-12" style={{ marginTop: 8 }}>
                                    <Button label="Testar/Imprimir arquivo existente" className="ui-button-info" onClick={() => {

                                        props.testarRelatorio();

                                    }} ></Button>
                                </div>

                            </>
                            :
                            <label className="col col-sm-12">Nenhum arquivo cadastrado</label>
                        }
                        <div className="col-sm-12" style={{ marginTop: 4 }}>
                            <FileUpload mode="basic" name="arquivos" ref={inputRelatorioFileRef} customUpload={true} accept="*" maxFileSize={10000000} uploadHandler={onUploadRelatorio} auto={true} chooseLabel="Escolher" />
                        </div>
                        {fileRelatorio ?
                            <div className="col-sm-12">
                                <label className="col col-sm-12">Novo arquivo: {fileRelatorio.name} (clique em gravar para realizar o upload e salvar o arquivo no servidor)</label>
                            </div>
                            : null}
                        <div className="col-sm-12" style={{ marginTop: 8 }}>

                        </div>
                    </div>
                </div>
            </div>

        </Panel>
    )
}

const ReportEdit = (props: Props) => {
    return <DefaultReportEdit {...props} />
}

ReportEdit.defaultProps = {
    style: {}
}

export default ReportEdit;